import { TranslateService } from '@ngx-translate/core';
import {
  AppMembershipEntity,
  AppMembershipRoleCompositeEntity,
  AppMembershipRoleEntity,
  AppRoleEntity,
  AppRoleKey,
} from '@nk/data-entities-lib';
import { arrayToDict, arrayUnique } from '@nk/utils-lib';

export interface AppRoleGroup {
  groupName: string;
  roles: AppRoleEntity[];
}

export function findUnusedRoles(
  allAppRoles: Required<AppRoleEntity>[],
  ...appMembershipRoleArrays: AppMembershipRoleEntity[][]
): Required<AppRoleEntity>[] {
  let unusedRoles: Required<AppRoleEntity>[] = [];
  for (const appMembershipRoles of appMembershipRoleArrays) {
    const appMembershipRolesDictByAppRole = arrayToDict(appMembershipRoles, (a) => a.app_role_uuid);
    unusedRoles = unusedRoles.concat(allAppRoles.filter((i) => !appMembershipRolesDictByAppRole[i.uuid]));
  }
  return arrayUnique(unusedRoles, (i) => i.uuid).sort((a, b) => {
    return a.app_role_key.localeCompare(b.app_role_key);
  });
}

export function findGivenRoles(
  appMembershipRoles: AppMembershipRoleEntity[],
  allAppRoles: Required<AppRoleEntity>[],
  appMembership: AppMembershipEntity,
): AppMembershipRoleCompositeEntity[] {
  const allAppRoleDict = arrayToDict(allAppRoles, (a) => a.uuid);
  return appMembershipRoles.map((i) => {
    return {
      app_role: allAppRoleDict[i.app_role_uuid],
      app_membership: appMembership,
      app_membership_role: i,
    };
  });
}

export const COMMON_ROLES = new Set([
  AppRoleKey.norwegian_mortgaged_movable_property_data,
  AppRoleKey.network_risk_score,
  AppRoleKey.fraud_risk_score,
  AppRoleKey.adverse_event,
  AppRoleKey.norwegian_property_data,
  AppRoleKey.bank_account_prevalidation,
  AppRoleKey.credit_check,
  AppRoleKey.person_national_identification,
  AppRoleKey.aml,
]);

export const HIDDEN_ROLES: Set<AppRoleKey> = new Set([
  AppRoleKey.experimental_flags,
  AppRoleKey.indicator_flags,
  AppRoleKey.customer_santander_flags,
]);

export function sortRolesAlphabetically(
  a: AppRoleEntity,
  b: AppRoleEntity,
  translateService: TranslateService,
): number {
  const aTitle = translateService.instant('membership_role.' + a.app_role_key) || a.app_role_key;
  const bTitle = translateService.instant('membership_role.' + b.app_role_key) || b.app_role_key;
  return aTitle.localeCompare(bTitle);
}
